import AppPanel from '../fw/AppPanel.react';
import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import {injectIntl, defineMessages, IntlShape} from 'react-intl';
import {wrapNotFound} from '../app/NotFoundHandler.react';
import types from '../../common/model-api/types';
import {getLastOrganisationId} from '../app/LastOrganisationId';
import PagingGrid, {defaultPageSize, processPagingParams} from '../fw/PagingGrid.react';
import urlMapping from '../app/URLMapping';
import { User } from '../../common/types/types';

const messages = defineMessages({
    title: {id: 'flowHooks.title', 'defaultMessage': 'Hooks'},
});

interface FlowHooksProps {
    intl: IntlShape;
    relay: object;
    user: User;
}

class FlowHooks extends React.Component<FlowHooksProps> {

    typeName = 'hooks';

    constructor(props) {
        super(props);
    }

    static propTypes = {
        intl: PropTypes.object.isRequired,
        relay: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired,
    };

    render() {
        let { user } = this.props;
        let { flow } = user.organisation;
        let type = types[this.typeName];
        let list = flow.hooks;

        return (
            <AppPanel breadcrumbParams={[
                {type: types['organisations'], data: this.props.user.organisation},
                {type: types['flows'], data: this.props.user.organisation.flow}
            ]} title={this.props.intl.formatMessage(messages.title)}>

                <PagingGrid
                        columns={{
                            'type': {},
                            'flowStepDef.name': {},
                            'nextInvoke': {},
                            'typeType': {},
                            'eventType': {},
                            'expression': {},
                            'email': {}
                        }}
                        edges={list}
                        metadata={type}
                        pageInfo={list.pageInfo}
                        parent={this.props.user.organisation.flow}
                        relay={this.props.relay}
                        renderLink={false}
                        urlMapping={urlMapping} />

            </AppPanel>
        );
    }
}

export default Relay.createContainer(wrapNotFound(injectIntl(FlowHooks), (props) => {
    return props.user.organisation && props.user.organisation.flow;
}), {
    initialVariables: {
        organisationId: '',
        flowId: '',
        first: defaultPageSize,
        after: null,
        before: null,
        last: null,
    },
    prepareVariables (variables) {
        processPagingParams(variables);

        if (!variables.organisationId) {
			variables.organisationId = getLastOrganisationId();
		}

        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                organisation(id: $organisationId) {
                    id,
                    name,
                    flow(id: $flowId) {
                        id,
                        realId,
                        organisation_id,
                        name,
                        flowDef {
                            id,
                            name,
                        },
                        hooks(first: $first, last: $last, after: $after, before: $before) {
                            edges {
                                node {
                                    id,
                                    realId,
                                    flow_id,
                                    organisation_id,
                                    type,
                                    eventType,
                                    typeType,
                                    nextInvoke,
                                    expression,
                                    email,
                                    flowStepDef {
                                        id,
                                        realId,
                                        name,
                                    }
                                }
                            },
                            pageInfo {
                                hasNextPage,
                                hasPreviousPage,
                                startCursor,
                                endCursor
                            }
                        }
                    }
                }
            }
        `,
    },
});
